var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tis-button',{staticClass:"btn-gold block text-sm cursor-pointer",attrs:{"url":_vm.url,"full-redirect":_vm.fullRedirect,"target":_vm.target,"title":_vm.title}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('svg-icon',{staticClass:"w-7 h-6 inline-block ml-3",attrs:{"icon":"arrow-horizontal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }